import React from "react";
import {IntlProvider, useIntl} from "react-intl";
import PropTypes from "prop-types";
import toastr from 'toastr';
import PayloadOverviewModal from "./PayloadOverviewModal";
import { translations } from "../../util/i18n";
import Modal from "../../util/Modal";
import RowMenu from "../../util/RowMenu";

const PayloadsRowMenu = ({payload}) => {
  const intl = useIntl();

  const options = [
    {
      title: "admin-area.payloads.payload-overview",
      component: Modal,
      params: {
        title: "admin-area.payloads.payload-overview",
        classNameForContent: "cancel-overflow-auto",
        content: PayloadOverviewModal({
          payload
        }),
      },
    },
  ];

  if (navigator.clipboard) {
    options.push({
      title: "admin-area.payloads.row-menu.copy-payload",
      onClick: async () => {
        try {
          await navigator.clipboard.writeText(payload);
          toastr.success(intl.formatMessage({ id: 'admin-area.payloads.copy-payload-success' }));
        } catch (err) {
          toastr.error(intl.formatMessage({ id: 'shared.something-wrong' }));
        }
      }
    })
  }

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <RowMenu options={options}></RowMenu>
    </IntlProvider>
  );
};

PayloadsRowMenu.propTypes = {
  payload: PropTypes.string.isRequired,
};

export default PayloadsRowMenu;
